<template>
  <div v-if="isInitial">
    <div class="content-wrapper">
      <div class="container">
        <article>
          <section class="section white-panel mb2p pt24">
            <div class="flex mb4">
              <p class="car-image radius50p">
                <img src="lib/images/ic_car.svg" alt="" class="car-img">
              </p>
              <div class="flex1 pl8">
                <p class="fs14 mt4 mb4">{{ Manufacturer.manufacturer_name }} {{ firstRegistrationOnWareki.gengo }}{{ $filters.checkFirstYear(firstRegistrationOnWareki.year) }}年{{ firstRegistrationOnWareki.month }}月登録</p>
                <p class="fs12 color-font2">車検受付ID {{ detail[0].id}}</p>
              </div>
            </div>
            <div v-if=" detail[0].status_code === 1 || detail[0].status_code === 2">
              <h2 class="fs16">見積り金額</h2>
              <div class="flex mb16">
                <p class="flex1 fs40 line-height1 font-weight-bold mb0">{{ $filters.addComma(detail[0].estimate_price) }}<span class="ml4 fs20 va-middle">円</span></p>
                <p class="fs14 font-weight-bold text-right mt12">
                  <router-link :to="{ name: 'EstimateDetail', params: { detail, nativeData }}" v-on:click.native="eventTrackInspectionDetail()">
                    <a href="#" target="_blank" class="color-green2 text-decoration-none icon-chevron-right">詳細金額</a>
                  </router-link>
                </p>
              </div>
            </div>
            <div v-else-if="detail[0].status_code === 3">
              <h2 class="fs16">見積り金額</h2>
              <div class="flex mb16">
                <p class="flex1 fs40 line-height1 font-weight-bold mb0">{{ $filters.addComma(detail[0].before_maintenance_price) }}<span class="ml4 fs20 va-middle">円</span></p>
                <p class="fs14 font-weight-bold text-right mt12">
                  <router-link :to="{ name: 'EstimateDetail', params: { detail, nativeData }}" v-on:click.native="eventTrackInspectionDetail()">
                    <a href="#" target="_blank" class="color-green2 text-decoration-none icon-chevron-right">詳細金額</a>
                  </router-link>
                </p>
              </div>
            </div>
            <div v-else-if="detail[0].status_code === 4 || detail[0].status_code === 5">
              <h2 class="fs16">精算金額</h2>
              <div class="flex mb16">
                <p class="flex1 fs40 line-height1 font-weight-bold mb0">{{ $filters.addComma(detail[0].payment_price) }}<span class="ml4 fs20 va-middle">円</span></p>
                <p class="fs14 font-weight-bold text-right mt12">
                  <router-link :to="{ name: 'EstimateDetail', params: { detail, nativeData }}" v-on:click.native="eventTrackInspectionDetail()">
                    <a href="#" target="_blank" class="color-green2 text-decoration-none icon-chevron-right">詳細金額</a>
                  </router-link>
                </p>
              </div>
            </div>
            <hr class="hr-solid-gray mb16">
            <Progress v-bind:detail="detail"></Progress>
            <div class="bg-gray1 pt24 pr16 pb20 pl16 mb8 radius8">
              <div class="flex">
                <p class="car-character-1 mb4">
                  <img src="lib/images/ic_car_character_1.svg" alt="" class="car-img">
                </p>
                <div v-if="detail[0].status_code === 1">
                  <p class="flex1 pl12 fs14 font-weight-bold mb0">SSからの電話をお待ちください。</p><br>
                  <p class="flex1 pl12 fs14 font-weight-bold mb0">特定商取引にかかわる表記については <a href="#" v-on:click="toAgreement()">こちら</a></p>
                </div>
                  <p v-if="detail[0].status_code === 4 && detail[0].payment_method_code === null" class="flex1 pl12 fs14 font-weight-bold">車検が終了しました。お車の受け取りの前に支払い方法を選択してください。</p>
                <div v-if="detail[0].status_code === 5 && detail[0].payment_method_code === 1">
                  <p class="flex1 pl12 fs14 font-weight-bold">クレジットカードでのお支払いを受け付けました。ご来店をお待ちしております。</p>
                </div>
                <div v-if="detail[0].status_code === 5 && detail[0].payment_method_code === 2">
                  <p class="flex1 pl12 fs14 font-weight-bold">現金払いでのお支払いを受け付けました。ご来店をお待ちしております。</p>
                </div>
                <div v-if="detail[0].status_code === 2" style="width: 100%;">
                  <div class="flex1 pl12">
                    <table class="table w100p fs14 font-weight-bold mb16">
                      <tbody>
                        <tr>
                          <th class="">来店予定</th>
                        </tr>
                        <tr>
                          <th class="">{{expectedInspection.year}}年{{expectedInspection.month}}月{{expectedInspection.date}}日 {{expectedInspection.hour}}時{{expectedInspection.minute}}分</th>
                        </tr>
                        <tr>
                          <th class="" v-if="detail[0].expected_return_at">車検完了予定</th>
                        </tr>
                        <tr>
                          <th class="" v-if="detail[0].expected_return_at">{{maintenanceCompleted.year}}年{{maintenanceCompleted.month}}月{{maintenanceCompleted.date}}日 {{maintenanceCompleted.hour}}時{{maintenanceCompleted.minute}}分</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-if="detail[0].status_code === 3" style="width: 100%;">
                  <div class="flex1 pl12">
                    <table class="table w100p fs14 font-weight-bold mb8">
                      <tbody>
                        <tr>
                          <th class="" v-if="detail[0].expected_return_at">車検完了予定</th>
                        </tr>
                        <tr>
                          <th class="" v-if="detail[0].expected_return_at">{{maintenanceCompleted.year}}年{{maintenanceCompleted.month}}月{{maintenanceCompleted.date}}日 {{maintenanceCompleted.hour}}時{{maintenanceCompleted.minute}}分</th>
                        </tr>
                        <tr>
                          <th class="" v-if="!detail[0].expected_return_at">車検が完了するのをお待ち下さい。</th>
                        </tr><br>
                        <tr>
                          <th class="fs14">特定商取引にかかわる表記については <a href="#" v-on:click="toAgreement()">こちら</a></th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-if="detail[0].status_code === 4 && detail[0].payment_method_code === 2">
                  <div class="flex1 pl12">
                    <p class="fs14 font-weight-bold mb20">現金でのお支払いを受け付けました。車検代金を用意し、店頭にてご精算をお願いいたします。</p>
                    <p class="fs14 mb16">店頭でのお支払いまでに支払い方法を変更できます</p>
                    <router-link :to="{ name: 'InspectionSettlement', query: { tsid: nativeData.tsid, otoken: nativeData.otoken , popinfoid: nativeData.popinfoid}}">
                      <p class="fs16 font-weight-bold mb8"><a href="#" target="_blank" class="color-green2 text-decoration-none">クレジットカード支払いに変更</a></p><br>
                    </router-link>
                  </div>
                </div>
              </div>
              <div v-if="detail[0].status_code === 2">
                <p class="fs13 mb4">ご来店当日は以下を忘れずにお持ちください</p>
                <p class="fs14 line-height1_7">自動車検査証（車検証）<br>
                  印鑑(認め印可)<br>
                  自動車納税証明書<br>
                自賠責証明書</p><br>
                  <p class="flex1 pl12 fs14 font-weight-bold mb0">特定商取引にかかわる表記については <a href="#" v-on:click="toAgreement()">こちら</a></p>
              </div>
              <div v-if="detail[0].status_code === 4 && detail[0].payment_method_code === null">
                <router-link :to="{ name: 'InspectionSettlement', query: { tsid: nativeData.tsid, otoken: nativeData.otoken, popinfoid: nativeData.popinfoid }}" style="text-decoration: none;">
                  <button class="button fs16 mt8 mb4 w90p">支払い方法の選択</button>
                </router-link><br>
                <div class="flex">
                  <p class="car-character-1 mb4"></p>
                  <p class="flex1 pl12 fs14 font-weight-bold mb0">特定商取引にかかわる表記については <a href="#" v-on:click="toAgreement()">こちら</a></p>
                </div>
              </div>
            </div>
          </section>

          <InspectionImplementationShop v-bind:detail="detail" v-bind:ssInfo="ssInfo"  v-bind:tsId="tsId" v-bind:nativeData="nativeData" v-bind:profileInfo="profileInfo"></InspectionImplementationShop>
          <Lease v-bind:car="car" v-bind:popInfoNo="nativeData.popinfoid"></Lease>
        </article>
      </div>
    </div>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<script>
import Lease from '@/views/Lease.vue'
import InspectionImplementationShop from '@/views/InspectionImplementationShop.vue'
import Progress from '@/views/Progress.vue'
import Agreement from '@/views/Agreement.vue'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data () {
    return {
      currentState: IS_INITIAL
    }
  },
  computed: {
    firstRegistrationOnWareki: function () {
      return this.toWareki(this.detail[0].inspection_estimate.first_registration_on)
    },
    expectedInspection: function () {
      const data = {}
      data.year = this.detail[0].expected_inspection_at.substr(0, 4)
      data.month = this.detail[0].expected_inspection_at.substr(5, 2)
      data.date = this.detail[0].expected_inspection_at.substr(8, 2)
      data.hour = this.detail[0].expected_inspection_at.substr(11, 2)
      data.minute = this.detail[0].expected_inspection_at.substr(14, 2)
      return data
    },
    maintenanceCompleted: function () {
      const data = {}
      data.year = this.detail[0].expected_return_at.substr(0, 4)
      data.month = this.detail[0].expected_return_at.substr(5, 2)
      data.date = this.detail[0].expected_return_at.substr(8, 2)
      data.hour = this.detail[0].expected_return_at.substr(11, 2)
      data.minute = this.detail[0].expected_return_at.substr(14, 2)
      return data
    },
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    }
  },
  methods: {
    eventTrackInspectionDetail () {
      // [eventTrack] カーケアTOP 車検詳細 タップ
      this.nativeEVENTSet('CarCareButton', 'MOVED_SHAKEN_SHOSAI', 'TAP')
    },
    toInitial () {
      this.currentState = IS_INITIAL
      this.appDisplayBack(false)
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.appDisplayBack(true)
      this.nativeEVENTSet('CarCareButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    }
  },
  components: {
    Lease,
    InspectionImplementationShop,
    Progress,
    Agreement
  },
  props: [
    'car',
    'detail',
    'ssInfo',
    'profileInfo',
    'Manufacturer',
    'tsId',
    'nativeData'
  ]
}

</script>
